import {useEffect, useMemo, useState} from 'react'
import {ProgressFullScreen} from 'molecules'
import {RgxMobileDevice} from 'utils/core'
import MobLapPas from './MobLapPas'
import WebLapPas from './WebLapPas'

export default function PrdLapPas() {
  const [device, setDevice] = useState(null)
  const detectDevice = () => {
    let isMobile = RgxMobileDevice.test(navigator.userAgent)
    setDevice(isMobile ? 'mobile' : 'web')
    // setDevice('mobile')
  }
  const Content = useMemo(() => {
    const lstContent = {
      mobile: MobLapPas,
      web: WebLapPas,
    }
    if (lstContent[device]) {
      return lstContent[device]
    }
    return <></>
  }, [device])
  useEffect(() => {
    detectDevice()
    return () => {}
  }, [])
  if (!device) {
    return <ProgressFullScreen visible={true} />
  }

  return <Content />
}
